import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { apiAdminLogin } from "@/lib/api";
import { toast } from "sonner";
import { Shield, Eye, EyeOff } from "lucide-react";

export default function AdminLoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await apiAdminLogin(username, password);
      localStorage.setItem("admin_token", data.access_token);
      toast.success("Accesso admin riuscito");
      nav("/admin");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[hsl(220_25%_8%)] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-xl bg-accent/20 flex items-center justify-center">
            <Shield className="w-6 h-6 text-accent" />
          </div>
          <div>
            <span className="font-serif text-xl font-bold text-white">IoCiSono</span>
            <p className="text-xs text-white/40">Pannello Admin</p>
          </div>
        </div>

        <Card className="bg-[hsl(220_18%_12%)] border-white/10">
          <CardContent className="p-8">
            <h1 className="font-serif text-xl font-bold text-white mb-6 text-center">Accesso Amministratore</h1>
            <form onSubmit={handleSubmit} className="space-y-5" data-testid="admin-login-form">
              <div className="space-y-2">
                <Label className="text-white/70">Username</Label>
                <Input
                  data-testid="admin-username"
                  placeholder="admin"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="bg-white/5 border-white/10 text-white placeholder:text-white/30"
                />
              </div>
              <div className="space-y-2">
                <Label className="text-white/70">Password</Label>
                <div className="relative">
                  <Input
                    data-testid="admin-password"
                    type={showPw ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="bg-white/5 border-white/10 text-white placeholder:text-white/30"
                  />
                  <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white transition-colors">
                    {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <Button type="submit" data-testid="admin-login-btn" className="w-full bg-accent hover:bg-accent/90 text-white" disabled={loading}>
                {loading ? "Accesso..." : "Accedi"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
